module.exports = __webpack_public_path__ + "static/pic03-b89fbd08484a729eb61761c4ee86bca4.png";